// Auto-detect backend URL based on current domain
export const getBackendURL = () => {
  if (typeof window === 'undefined') return process.env.REACT_APP_BACKEND_URL;
  
  if (window.location.hostname === 'cosmobeauty.no' || window.location.hostname === 'www.cosmobeauty.no') {
    return 'https://cosmobeauty.no';
  }
  return process.env.REACT_APP_BACKEND_URL || window.location.origin;
};

export const BACKEND_URL = getBackendURL();
export const API_URL = `${BACKEND_URL}/api`;
